import { Avatar, Button, Checkbox, Col, Flex, Form, Image, Input, InputNumber, Radio, Row, Select, Space, Table, Tabs, Tag, Tooltip, Upload } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaCubes } from 'react-icons/fa';
import { Link, useParams, useLoaderData, useOutletContext, useNavigate } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import { RxUpdate } from "react-icons/rx";
import EventEmitter from '../../../utils/eventEmitter';
import useProductAPI from '../../apis/productAPI';
import { TbCameraPlus } from "react-icons/tb";
import { attributeVariantColumns, productPackagingColumns, productPurchaseTabColumns } from '../../utils/TableColumns';
import EditableTable from '../../../globalComponents/EditableTable';
import SmartButton from '../../../globalComponents/SmartButton';
import { TfiMenuAlt } from "react-icons/tfi";
import { BiWorld } from "react-icons/bi";
import { GoArrowSwitch } from "react-icons/go";
import { FiRefreshCw } from "react-icons/fi";
import { FcMultipleInputs } from "react-icons/fc";



const productTypes = [
  {value: 'storable', label: 'Storable Product', invoice_policy: [
    {value: 'ordered_quantities', label: 'Ordered Quantities'},
    {value: 'delivered_quantities', label: 'Delivered Quantities'}
  ]},
  {value: 'service', label: 'Service', invoice_policy: [
    {value: 'prepaid_fixed', label: 'Prepaid/Fixed'},
    {value: 'timesheet', label: 'Based on Timesheet'},
    {value: 'milestone', label: 'Based on Milestone'},
    {value: 'delivered_quantity', label: 'Based on Delivered Quantity'}
  ]}, 
  {value: 'consumable', label: 'Consumable Products'}, 
];


const normFile = (e) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
};
const onPreview = async (file) => {
  let src = file.url;
  if (!src) {
    src = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => resolve(reader.result);
    });
  }
  const image = new Image();
  image.src = src;
  const imgWindow = window.open(src);
  imgWindow?.document.write(image.outerHTML);
}
const ProductChanges = () => {
  const [form] = Form.useForm();
  const {categories, taxes, tags, product, locations, attributes, vendorList, routes} = useLoaderData();
  const { success, error, CustomBreadcrumb } = useOutletContext();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(product.name ? product.name : '');
  const { create, update } = useProductAPI();
  const [vendors, setVendors] = useState(product.name ? product.vendorproducts : []);
  const [productAttributes, setProductAttributes] = useState(product.name ? product.productvariants : []);
  const [fileList, setFileList] = useState([]);
  const [image, setImage] = useState(product.image_uri ? product.image_uri : '');

  const [invoicePolicy, setInvoicePolicy] = useState(productTypes[0].invoice_policy);
  // console.log(product);
  
  const onChangeName = (e) => setName(e.target.value);

  const save = () => {
    const formData = new FormData();
    formData.append('image', fileList[0].file);
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    Object.entries(data).forEach(([key, value]) => {
      if (value === undefined) {
        data[key] = null;
      }
    });
    data['vendors'] = vendors;
    data['variants'] = productAttributes;
    formData.append('details', JSON.stringify(data));
    create(formData, data.seo, success);
    // console.log(data);
  }

  const edit = () => { 
    const formData = new FormData();
    formData.append('image', fileList[0]?.file);
    let data = form.getFieldsValue();
    data['name'] = name;
    // data['id'] = product.id;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    Object.entries(data).forEach(([key, value]) => {
      if (value === undefined) {
        data[key] = null;
      }
    });
    data['vendors'] = vendors;
    data.image_uri = product.image_uri;
    formData.append('details', JSON.stringify(data));

    update(product.seo, formData, success);
  };

  useEffect(() => {
    EventEmitter.subscribe('product_response', data => {
      navigate('/inventory/products/'+data);
    });

    // if (product) {
    //   product.tags.forEach(tag => {
    //     let tag_ = 
    //   });
    //   if (tagIndex !== -1) {
    //     console.log(tagIndex)
    //   }
    //   // form.setFieldValue('tagColor'+tag.id, tag.color);
    // }
    return () => EventEmitter.unsubscribe('product_response');
  },[])
  // console.log(product)
  // console.log(product)
  const onChangeProductType = (option) => {
    if (option.value === 'storable') {
      setInvoicePolicy(option.invoice_policy);
    }else if (option.value === 'consumable') {
      setInvoicePolicy(option.invoice_policy);
    }else if (option.value === 'service') {
      setInvoicePolicy(option.invoice_policy);
    }
  }


  const addVendorLine = () => {
    let vendors_ = [...vendors];
    const obj = {
      key: vendors.length,
      vendor_id: '',
      quantity: 0,
      price: 0
    };
    vendors_.push(obj);
    setVendors(vendors_);
  }
  // console.log(attributes)
  const addVariant = () => {
    let variants = [...productAttributes];
    const obj = {
      key: productAttributes.length,
      attribute_id: '',
      values: []
    };
    variants.push(obj);
    setProductAttributes(variants);
  }


  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },

    beforeUpload: async (file) => {
      let src = file.url;
      if (!src) {
        src = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => resolve(reader.result);
        });
      };
      let imageFile = {uid: file.uid, name: file.name, status: 'done', url: src};
      setImage(src);
      // setFileList([file]);
      return false;
    },
    onChange: (file) => {
      setFileList([file]);
    },
    previewFile: (file) => console.log(file),
    fileList: fileList,
  };

//  console.log(fileList)

  return (
    <div className='container mx-auto' style={{ maxWidth: '1000px' }}>
      <div className='flex justify-between'>
        <div>
          <h3 className='font-bold flex'>
            <Link to={'/inventory/products'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'><CustomBreadcrumb /> </Link>
            <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={save} type='text' htmlType='button'
              disabled={product.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={edit} type='text' htmlType='button'
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
          </h3>
        </div>
        {product.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}

      </div>
      <div className='mt-3 bg-white p-1'>
        <Button size='small' type='primary' className='font-semibold bg-[#189aa0] hover-btn'>REPLENISH</Button>
      </div>
      <div className='mt-5 bg-white shadow'>
        <Flex className='border-b m-0'>
          <SmartButton icon={<TfiMenuAlt size={'1.4rem'}/>} number={0} text={'Extra Prices'}/>
          <SmartButton icon={<BiWorld size={'1.4rem'} />} text={'Website'} number={'Go to'}/>
          <SmartButton icon={<FaCubes size={'1.4rem'} />} text={'On Hand'} number={product.on_hand ? product.on_hand : 0+' units'} to={product.seo && '/inventory/products/'+product.seo+'/update-quantity'}/>
          <SmartButton icon={<FaCubes size={'1.4rem'} />} text={'Forecasted'} number={product.forecasted ? product.forecasted : 0+' units'}/>
          <SmartButton icon={<GoArrowSwitch size={'1.4rem'} />} text={<div className='flex justify-between gap-2 text-slate-600 text-sm'>Out: <span className='text-[#189aa0] text-sm font-semibold'>0</span></div>} number={<div className='flex justify-between text-slate-600 text-sm'>In: <span className='text-[#189aa0] text-sm font-semibold'>0</span></div>}/>
          <SmartButton icon={<FiRefreshCw size={'1.4rem'} />} text={'Reordering'} number={product.reordering} to={product.seo && '/inventory/products/'+product.seo+'/reordering'}/>
          <SmartButton icon={<FcMultipleInputs size={'1.4rem'} />} text={'Rule'} number={'Putaway'} to={product.seo && '/inventory/products/'+product.seo+'/putawayrule'}/>
        </Flex>
        <Form
          form={form}
          className='p-3'
          labelAlign='left'
          labelCol={{ span: 8 }}
          labelWrap={true}
          initialValues={product.name ? product : {
            tracking: 'no_tracking',
            routes: ['buy'],
            control_policy: 'on_received_quantities',
            type: 'storable',
            invoicing_policy: 'ordered_quantities',
            operation_type: ['saleable', 'purchasable'],
            sales_price: 0,
            cost_price: 0,
            pos_availability: true,
            qty_availability: true
          }}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Row className='mt-5'>
            <Col md={{ span: 15 }}>
              <FloatingLabel
                className='text-2xl'
                variant="standard"
                // disabled={formValue.status!== 'discard' ? true : false}
                placeholder="Product Name"
                value={name} 
                onChange={onChangeName}
              />
              <Row>
                <Col sm={{span: 24}}>
                  <Form.Item name="operation_type" className='font-bold mb-2' required >
                    <Checkbox.Group>
                      <Space direction='horizontal'>
                        <Checkbox value={'saleable'}>Can be Sold</Checkbox>
                        <Checkbox value={'purchasable'}>Can be Purchase</Checkbox>
                        <Checkbox value={'expensable'}>Can be Expense</Checkbox>
                        <Checkbox value={'delivery_fee'}>Is Delivery Fee</Checkbox>
                        
                      </Space>
                    </Checkbox.Group>
                  </Form.Item>
                </Col>
                {/* <Col md={{span: 6}}>
                  <Form.Item name="can_be_purchase" className='font-bold mb-2' valuePropName='checked' required >
                    <Checkbox>Can be Purchase</Checkbox>
                  </Form.Item>
                </Col>
                <Col md={{span: 6}}>
                  <Form.Item name="can_be_expense" className='font-bold mb-2' valuePropName='checked' required >
                    <Checkbox>Can be Expense</Checkbox>
                  </Form.Item>
                </Col> */}
              </Row>
              
            </Col>
            <Col md={{ span: 3, offset: 6 }}>
              <Form.Item valuePropName="fileList" getValueFromEvent={normFile}>
                <Upload
                  {...props}
                  name="picture"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  // openFileDialogOnClick={false}
                  
                  // maxCount={1}
                  onPreview={onPreview}
                  // previewFile={previewFile}
                >
                {image.length === 0 ? <Avatar icon={<TbCameraPlus />} /> : <img src={image} />
                }
                </Upload>
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            className='mt-3'
            type='card'
            items={[
              {
                key: 1,
                label: 'General Information',
                children:
                  <Row>
                    <Col lg={{ span: 11 }}>
                      <Form.Item label='Product Type' name="type" className='font-semibold text-gray-800 mb-2' required >
                        <Select options={productTypes} onChange={(v, option) => onChangeProductType(option)}/>
                      </Form.Item>
                      <Form.Item label='Invoicing Policy' name="invoicing_policy" className='font-semibold text-gray-800 mb-2' required >
                        <Select options={invoicePolicy}/>
                      </Form.Item>
                    </Col>
                    <Col lg={{span: 11, offset: 1}}>
                      <Form.Item label='Sales Price' name='sales_price' className='font-semibold mb-1' >
                        <InputNumber className='font-normal w-full'/>
                      </Form.Item>
                      <Form.Item label='Customer Taxes' name="customer_tax_id" className='font-semibold text-gray-800 mb-1' >
                        <Select options={taxes.map(tax => ({value: tax.id, label: tax.name}) )} style={{width: '100%'}}/>
                      </Form.Item>
                      <Form.Item label='Cost' name='cost_price' className='font-semibold mb-1' >
                        <InputNumber className='font-normal w-full'/>
                      </Form.Item>
                      <Form.Item label='Product Category' name='category_id' className='font-semibold mb-1'>
                        <Select options={categories.map(category => ({value: category.id, label: category.name}))} className='font-normal' style={{width: '100%'}}/>
                      </Form.Item>
                      <Form.Item label='Internal Reference' name='internal_reference' className='font-semibold mb-1'>
                        <Input type='text' placeholder='This can be the product SKU' className='font-normal input-outline-none'/>
                      </Form.Item>
                      <Form.Item label='Product Tags' name='tags' className='font-semibold mb-1'>
                        <Select options={tags.map(tag => ({value: tag.id, label: tag.name, color: tag.color}))} tagRender={(props) => <Tag style={{color: 'white', backgroundColor: form.getFieldValue('tagColor'+props.value)}}>{props.label}</Tag>} onChange={(v, option) => form.setFieldValue('tagColor'+v, option.length>0 ? option[0].color : '')} mode='tags' className='font-normal'/>
                      </Form.Item>
                    </Col>
                    <Form.Item name='internal_notes' className='font-semibold mb-1 border-y-2 w-full mt-2'>
                      <Input type='text' placeholder='This note is only for internal purposes' className='font-normal input-outline-none ps-0'/>
                    </Form.Item>
                  </Row>
              },
              {
                key: 2,
                label: 'Attribute & Variants',
                children: 
                  <EditableTable 
                  columns={attributeVariantColumns}
                  dataSource={productAttributes}
                  setDataSource={setProductAttributes}
                  addLine={addVariant}
                  option1={[]}
                  disableSummary={true}
                  attributes={attributes}
                />
              },
              {
                key: 3, 
                label: 'Sales',
                forceRender: true,
                children: 
                  <>
                    <Row className='mb-3'>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 mb-3">UPSELL & CROSS-SELL</Badge>
                        <Form.Item label='Optional Products' name='optional_products' className='font-semibold mb-1'>
                          <Select mode='tags' className='font-normal'/>
                        </Form.Item>
                        <Form.Item label='Accessory Products' name='accessory_products' className='font-semibold mb-1'>
                          <Select mode='tags' className='font-normal'/>
                        </Form.Item>
                        <Form.Item label='Alternative Products' name='alternative_products' className='font-semibold mb-1'>
                          <Select mode='tags' className='font-normal'/>
                        </Form.Item>
                      </Col>
                      <Col md={{span: 11, offset: 1}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent border-b-2 mb-3">POINT OF SALE</Badge>
                        <Form.Item label='Available in PoS' name="pos_availability" className='font-semibold mb-2' valuePropName='checked' required >
                          <Checkbox />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 mb-3">ECOMMERCE SHOP</Badge>
                        <Form.Item label='Website' name='website' className='font-semibold mb-1'>
                          <Input type='url' className='font-normal input-outline-none'/>
                        </Form.Item>
                        <Form.Item label='Website Sequence' name='website_sequence' className='font-semibold mb-1'>
                          <Input type='text' className='font-normal input-outline-none'/>
                        </Form.Item>
                        <Form.Item label='Category' name='e_category' className='font-semibold mb-1'>
                          <Select className='font-normal'/>
                        </Form.Item>
                        <Form.Item label='Show Available Qty' name='qty_availability' className='font-semibold mb-1' valuePropName='checked'>
                          <Checkbox />
                        </Form.Item>
                        <Form.Item label='Out-of-Stock Message' name='out_of_stock_message' className='font-semibold mb-1' >
                          <Input type='text' className='font-normal input-outline-none' />
                        </Form.Item>
                      </Col>
                      <Col md={{span: 11, offset: 1}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 mb-3">EXTRA PRODUCT MEDIA</Badge>
                        <Button className='border-0'>ADD A MEDIA</Button>
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 mb-3">SALES DESCRIPTION</Badge>
                        <Form.Item name='sales_description' className='font-semibold mb-1' >
                          <Input type='text' placeholder='This note is added to sales order and invoices' className='font-normal input-outline-none' />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
              },
              {
                key: 4,
                label: 'Purchase',
                forceRender: true,
                children: 
                  <>
                    <EditableTable 
                      columns={productPurchaseTabColumns}
                      dataSource={vendors}
                      setDataSource={setVendors}
                      addLine={addVendorLine}
                      option1={[]}
                      disableSummary={true}
                      contacts={vendorList}
                    />
                    <Row>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">VENDOR BILLS</Badge>
                        <Form.Item label='Vendor Taxes' name="vendor_taxes" className='font-semibold text-gray-800 mb-1' >
                          <Select options={[]} style={{width: '100%'}}/>
                        </Form.Item>
                        <Form.Item label='Control Policy' name="control_policy" className='font-semibold text-gray-800 mb-1' >
                          <Radio.Group>
                            <Radio value={'on_ordered_quantities'}>On Ordered Quantities</Radio>
                            <Radio value={'on_received_quantities'}>On Received Quantities</Radio>
                          </Radio.Group>
                        </Form.Item>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">PURCHASE DESCRIPTION</Badge>
                        <Form.Item name='purchase_description' className='font-semibold mb-1' >
                          <Input type='text' placeholder='This note is added to purchase order' className='font-normal input-outline-none' />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
              },
              {
                key: 5,
                label: 'Inventory',
                forceRender: true,
                children: 
                  <>
                    <Row className='mb-3'>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">OPERATIONS</Badge>
                        <Form.Item label='Routes' name="routes" className='font-semibold text-gray-800 mb-1' >
                          <Checkbox.Group>
                            <Space direction='vertical'>
                              {routes.map( route => 
                                <Checkbox key={route.id} value={route.id}>{route.name}</Checkbox>
                              )}
                            </Space>
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                      <Col md={{span: 11, offset: 1}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">LOGISTICS</Badge>
                        <Form.Item label='Responsible' name="responsible" className='font-semibold text-gray-800 mb-1' >
                          <Select options={[]} className='font-normal' />
                        </Form.Item>
                        <Form.Item label='Weight' name="weight" className='font-semibold text-gray-800 mb-1' >
                          <InputNumber className='font-normal w-full' />
                        </Form.Item>
                        <Form.Item label='Volume' name="volume" className='font-semibold text-gray-800 mb-1' >
                          <InputNumber className='font-normal w-full' />
                        </Form.Item>
                        <Form.Item label='Customer Lead Time' name="customer_lead_time" className='font-semibold text-gray-800 mb-1' >
                          <InputNumber className='font-normal w-full' />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">TRACEABILITY</Badge>
                        <Form.Item label='Tracking' name="tracking" className='font-semibold text-gray-800 mb-1' >
                          <Radio.Group>
                            <Space direction='vertical'>
                              <Radio value={'by_serial_number'}>By Unique Serial Number</Radio>
                              <Radio value={'by_lots'}>By Lots</Radio>
                              <Radio value={'no_tracking'}>No tracking</Radio>
                            </Space>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                      <Col md={{span: 11, offset: 1}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">COUNTERPARTS LOCATIONS</Badge>
                        <Form.Item label='Inventory Location' name="inventory_location" className='font-semibold text-gray-800 mb-1' >
                          <Select options={locations.map(location => ({value: location.id, label: location.name}))} className='font-normal' />
                        </Form.Item>
                      </Col>
                    </Row>
                    <div className='mb-3'>
                      <Table 
                        columns={productPackagingColumns}
                        dataSource={vendors}
                      />
                      <Button className='border-0'>Add Line</Button>
                    </div>
                    <Row className='mb-4'>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">DESCRIPTION FOR RECEIPTS</Badge>
                        <Form.Item name='receipt_description' className='font-semibold mb-1' >
                          <Input type='text' placeholder='This note is added to receipt orders (eg. where to store the product in the warehouse)' className='font-normal input-outline-none' />
                        </Form.Item>
                      </Col>
                      <Col md={{span: 11, offset: 1}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">DESCRIPTION FOR DELIVERY ORDERS</Badge>
                        <Form.Item name='delivery_description' className='font-semibold mb-1' >
                          <Input type='text' placeholder='This note is added to delivery orders' className='font-normal input-outline-none' />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">DESCRIPTION FOR INTERNAL TRANSFER</Badge>
                        <Form.Item name='internal_transfer_description' className='font-semibold mb-1' >
                          <Input type='text' placeholder='This note is added to internal transfer orders (eg. where to pick the product in the warehouse)' className='font-normal input-outline-none' />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
              },
              {
                key: 6,
                label: 'Accounting',
                forceRender: true,
                children: 
                  <>
                    <Row className='mb-3'>
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">RECEIVABLES</Badge>
                        <Form.Item label='Income Account' name='income_account' className='font-semibold mb-1' >
                          <Select options={[]} className='font-normal' />
                        </Form.Item>
                      </Col>  
                      <Col md={{span: 11}}>
                        <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">PAYABLES</Badge>
                        <Form.Item label='Expense Account' name='expense_account' className='font-semibold mb-1' >
                          <Select options={[]} className='font-normal' />
                        </Form.Item>
                      </Col>  
                    </Row>  
                  </>
              }
            ]}
          />
        </Form>
      </div>
    </div>
  )
}

export default ProductChanges;